var map = {
	"./bash": 1697,
	"./java": 1698,
	"./json": 1699,
	"./julia": 1700,
	"./python": 1701,
	"./r": 1702,
	"./rust": 1703,
	"./scala": 1704,
	"./shell": 1705,
	"./sql": 1706,
	"./xml": 1707,
	"./yaml": 1708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1696;